module.exports = __webpack_public_path__ + "static/media/ag-staffNM2.96ba9109.jpg";